{
  "_meta": {
    "status": "REVIEWED",
    "warning": "Polished to match Barkibu modern, friendly tone. Using strict 'ti' communication."
  },
  "common": {
    "to": "do",
    "from": "od"
  },
  "missing_info": {
    "clinical_history": "Što je to povijest bolesti (veterinarski karton)?\n\nTo je dokument koji sadržava baš sve posjete veterinaru, od onih zbog bolesti ili nesreće, pa do rutinskih pregleda i cijepljenja, zajedno s datumima i bilješkama veterinara. Svaka stranica mora biti numerirana, a na zadnjoj nam treba potpis i pečat klinike. Također, trebat će nam i potvrda da su ti zabilježeni posjeti ujedno i jedini puta kad je tvoj ljubimac bio u toj klinici.\n\nKako doći do veterinarskog kartona?\n\nSuper jednostavno! Samo zamoli svog veterinara da ti ga isprinta ili pošalje. Ako ste išli u više različitih klinika, morat ćeš ga zatražiti u svakoj od njih (čak i ako ste tamo išli samo na cijepljenje).",
    "vet_report": "Veterinarski izvještaj\n\nOvaj dokument detaljno opisuje pregled za koji tražiš povrat novca. Unutra moraju biti sljedeći podaci:\n    • Razlog posjeta (npr. „pas šepa na stražnju nogu”)\n    • Simptomi (npr. „bol na dodir, kvržica...”)\n    • Kada su se simptomi točno pojavili\n    • Obavljene pretrage (npr. rendgen, ultrazvuk, opći pregled...)\n    • Dijagnoza (npr. „istegnuće mišića zbog udarca”)\n    • terapija ili liječenje (npr. „mirovanje, tablete protiv bolova...”)\n    • Datum iduće kontrole.",
    "invoice": "Račun\n\nDa bismo mogli prihvatiti račun, on mora sadržavati:\n    • Datum izdavanja\n    • OIB veterinarske stanice ili ljekarne\n    • Broj računa\n    • Jasnu oznaku da je riječ o računu (ponude, predračuni ili obični blagajnički isječci nažalost ne vrijede)\n    • Specifikaciju troškova (točan popis usluga i lijekova)\n\nAko je fotka koju si nam poslao mutna, odrezana ili slabe rezolucije, samo nam pošalji novu, čišću fotku kako bismo mogli pročitati sve podatke.",
    "health": {
      "templates": [
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "One single document",
              "value": "Molimo te da nam račun pošalješ kao jedan dokument, idealno u PDF-u. Ovako nam se malo pomiješao redoslijed. Ako imaš tiskani račun koji treba pofotkati, samo pazi da cijeli stane na jednu sliku."
            },
            {
              "label": "Invoice complete",
              "value": "Treba nam kompletan račun. Najbolje je da ga preuzmeš u PDF formatu i učitaš u aplikaciju, na mjesto za račune. Više spojenih screenshotova nam nažalost ne vrijedi."
            },
            {
              "label": "Unreadable",
              "value": "Račun koji si poslao je mutan ili odrezan. Molimo te da nam pošalješ čitljiv, kompletan račun u PDF-u."
            },
            {
              "label": "Duplicated same invoice",
              "value": "Izgleda da imamo dupli broj računa; račun s ovim brojem si nam već poslao.\n\n<b>Svaki račun mora imati svoj jedinstveni broj.</b> Ne mogu postojati dva računa od istog izdavatelja s istim brojem u istoj godini.\n\nMolimo te da se javiš svojoj klinici kako bi ti izdali ispravan račun i pošalji nam novu verziju (s potpisom i pečatom)."
            },
            {
              "label": "Duplicated other invoice",
              "value": "Ovaj broj računa nam je već u sustavu, ali pod drugim ljubimcem.\n\n<b>Svaki račun mora imati svoj jedinstveni broj.</b> Ne mogu postojati dva računa od istog izdavatelja s istim brojem u istoj godini.\n\nMolimo te da se javiš svojoj klinici kako bi ti izdali ispravan račun s točnim brojem, pa nam ga pošalji."
            },
            {
              "label": "The receipt covers the invoice",
              "value": "Slip od kartice ili blagajnički isječak je prekrio račun, pa ne vidimo podatke ispod njega. Makni ga i pofotkaj ponovno!"
            },
            {
              "label": "Duplicated invoice",
              "value": "Ovaj račun je već iskorišten za drugog ljubimca. Budući da računi moraju imati jedinstvene brojeve, molimo te da kontaktiraš kliniku i zatražiš ispravan račun za ovog ljubimca."
            },
            {
              "label": "More than one pet",
              "value": "Na ovom računu su pomiješani troškovi za više ljubimaca. Molimo te da nam pošalješ odvojeni račun za svakog osiguranog ljubimca."
            },
            {
              "label": "Missing invoice",
              "value": "Treba nam račun za obavljene usluge. Pazi samo da na njemu jasno pišu <b>OIB</b> klinike, <b>broj računa</b> i <b>datum</b>."
            },
            {
              "label": "Wrong pet",
              "value": "Račun koji si poslao ne odgovara ljubimcu koji je osiguran na ovoj polici."
            },
            {
              "label": "Invoice not paid",
              "value": "Ovaj račun nije plaćen ili je plaćen samo djelomično. Možemo ti vratiti novac samo za račune koji su podmireni u cijelosti."
            },
            {
              "label": "Not an invoice",
              "value": "Dokument koji si nam poslao nije službeni račun. Bez brige, samo se javi svom veterinaru ili ljekarni da ti izdaju onaj pravi račun na kojem se jasno vide <b>OIB</b> klinike, <b>broj računa</b> i <b>datum</b>. Ponude, predračuni ili računi s brojem 0 nam nažalost ne vrijede prema uvjetima osiguranja."
            },
            {
              "label": "Invoice number",
              "value": "Na računu koji si poslao/la nedostaje broj računa."
            },
            {
              "label": "CIF",
              "value": "Ovo nije službeni račun. Molimo te da zamoliš veterinara da ti izda račun na kojem je jasno vidljiv OIB klinike."
            },
            {
              "label": "Upfront payment",
              "value": "Iz računa se vidi da je dio iznosa plaćen ranije kao predujam. Kako bismo ti odobrili povrat, trebat će nam i račun za tu prvu uplatu."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Primili smo tvoj zahtjev za povrat novca, ali nažalost ne možemo prihvatiti screenshotove ni fotografije ekrana. Zamoli svoju kliniku da ti dokumente izda u PDF-u i učitaj ih u aplikaciju."
            },
            {
              "label": "Signed and stamped",
              "value": "Treba nam račun s potpisom i pečatom tvog veterinara. Zamoli kliniku da ti ga tako izda i pošalji nam ga, najbolje u PDF-u."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Treba nam povijest bolesti (veterinarski karton) tvog ljubimca otkad je kod tebe. Zatraži je u svim klinikama u kojima se liječio. Unutra mora biti:\n - <b>Svi posjeti:</b> cijepljenja, kontrole, bolesti ili nesreće.\n - <b>Datumi i bilješke</b> koje je veterinar zapisao tijekom pregleda.\n - <b>Potvrda da je veterinarski karton kompletan:</b> veterinar treba dopisati nešto poput: „Nema drugih zabilježenih posjeta u ovoj klinici”.\n - <b>Potpis i pečat</b> klinike.\n - Ne možemo prihvatiti pojedinačne nalaze ili nepotpune papire."
            },
            {
              "label": "Loose sheets",
              "value": "Treba nam kompletna povijest bolesti u jednom dokumentu. Pojedinačne, nepovezane stranice nam nažalost ne vrijede."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Što nedostaje?",
                "options": [
                  {
                    "label": "Condition",
                    "value": "U povijesti bolesti (veterinarskom kartonu) nedostaje zabilježen posjet za stanje {{condicion;STRING;true}} koje se spominje u izvještaju."
                  },
                  {
                    "label": "Clinic data",
                    "value": "Nedostaju podaci o veterinarskoj klinici (naziv, OIB i/ili adresa)."
                  },
                  {
                    "label": "Pet details",
                    "value": "U povijesti bolesti (veterinarskom kartonu) nedostaju podaci o ljubimcu: ime, pasmina i/ili broj mikročipa."
                  },
                  {
                    "label": "Visit dates",
                    "value": "U povijesti bolesti nedostaju ovi datumi posjeta: {{fechas;DATE_RANGE;true}}"
                  },
                  {
                    "label": "Clinical notes",
                    "value": "U povijesti bolesti (veterinarskom kartonu) nedostaju detaljne bilješke veterinara za obavljene preglede."
                  },
                  {
                    "label": "One or more clinics",
                    "value": "Nedostaju nam posjeti iz jedne ili više klinika: {{nombre_clínica;STRING;true}}."
                  }
                ]
              }
            },
            {
              "label": "Not a clinical history",
              "value": "Dokument koji si poslao nije kompletna povijest bolesti (veterinarski karton). Molimo te da je zatražiš u svim klinikama u kojima se tvoj ljubimac liječio. Povijest bolesti mora sadržavati:\n - <b>Sve posjete:</b> cijepljenja, redovni pregledi, bolesti ili nesreće.\n - <b>Datumi i bilješke</b> koje je veterinar zapisao.\n - <b>Potvrda da je veterinarski karton kompletan:</b> veterinar treba dopisati nešto poput: „Nema drugih zabilježenih posjeta u ovoj klinici”.\n - <b>Potpis i pečat</b> klinike."
            },
            {
              "label": "Repeated attempts",
              "value": "Kao što smo te već ranije podsjetili, bez cjelokupnog veterinarskog kartona tvog ljubimca ne možemo obraditi povrat novca. Javi se klinikama u kojima ste bili i zatraži povijest bolesti. Ona mora sadržavati:\n - <b>Sve posjete:</b> cijepljenja, kontrole, bolesti ili nesreće.\n - <b>Datumi i bilješke</b> veterinara.\n - <b>Potvrda da je veterinarski karton kompletan</b> („Nema drugih zabilježenih posjeta”).\n - <b>Potpis i pečat</b> klinike."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline Explanation",
              "value": {
                "group": "Explanation",
                "options": [
                  {
                    "label": "All",
                    "value": "Zamoli svog veterinara da u izvještaju ili u dodatku računu pojasni na što se točno odnosi koja stavka troška (naziv tretmana i cijena), jer nam neke stvari trenutno nisu jasne."
                  },
                  {
                    "label": "One or more costlines",
                    "value": "Zamoli svog veterinara da u izvještaju ili dodatku računu pojasni na što se odnose ove stavke: {{línea_de_coste;STRING;true}}. Treba nam naziv tretmana i njegova pojedinačna cijena."
                  }
                ]
              }
            },
            {
              "label": "Sessions",
              "value": "Treba nam izvještaj koji prikazuje sve odrađene termine s točnim datumima. Molimo te da nam ovaj izvještaj pošalješ tek kad cijela terapija završi, jer ne možemo vratiti novac za termine koji još nisu odrađeni."
            },
            {
              "label": "Changes",
              "value": "Veterinarski izvještaj je službeni dokument i na njemu ne smije biti naknadnih prepravaka. Trebat će nam novi, službeni izvještaj s pečatom, potpisom, punim imenom i brojem licence veterinara koji opravdava nastale promjene."
            },
            {
              "label": "One document",
              "value": "Pošalji nam izvještaj kao jedan dokument, idealno u PDF-u. Ovako nam je teško pratiti točan redoslijed. Ako fotkaš tiskani izvještaj, samo pazi da svaka stranica bude na zasebnoj, čistoj fotki i da idu po redu."
            },
            {
              "label": "Missing vet report",
              "value": {
                "group": "Što nedostaje?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Nedostaje nam veterinarski izvještaj iz ove klinike: {{clinica;STRING;true}}."
                  },
                  {
                    "label": "Complete Vet report",
                    "value": "Treba nam veterinarski izvještaj. To je dokument koji piše veterinar i u kojem detaljno opisuje pregled za koji tražiš povrat. Izvještaj mora sadržavati:\n\n<b>Razlog posjeta:</b> npr. „Pas šepa na stražnju nogu.”\n\n<b>Simptomi:</b> npr. „Bol na dodir, šepanje.”\n\n<b>Kada su simptomi počeli.</b>\n\n<b>Pretrage:</b> npr. „Rendgen, opći pregled.”\n\n<b>Dijagnoza:</b> npr. „Istegnuće mišića.”\n\n<b>Terapija:</b> npr. „Mirovanje, tablete.”"
                  },
                  {
                    "label": "Date",
                    "value": "Nedostaje nam veterinarski izvještaj za ove datume: {{fecha;DATE_RANGE;true}}."
                  }
                ]
              }
            },
            {
              "label": "Date of symptoms",
              "value": {
                "group": "Tko treba navesti datum pojave simptoma?",
                "options": [
                  {
                    "label": "Petparent",
                    "value": "Samo nam upiši datum kada su se točno pojavili prvi simptomi.",
                    "type": "DATE"
                  },
                  {
                    "label": "Vet",
                    "value": "U izvještaju ne piše kada su se točno pojavili prvi simptomi. Zamoli svog veterinara da dopiše taj datum."
                  }
                ]
              }
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Što nedostaje?",
                "options": [
                  {
                    "label": "Costline explanation",
                    "value": "U izvještaju se ne spominju neke stavke koje vidimo na računu. Primjerice, ako su na računu lijekovi, a u izvještaju ih nema, veterinar će morati ažurirati izvještaj i navesti sve primijenjene terapije."
                  },
                  {
                    "label": "Clinic data",
                    "value": "U izvještaju nedostaju podaci o klinici: naziv, OIB i adresa."
                  },
                  {
                    "label": "Pet details",
                    "value": "U izvještaju nedostaju podaci o ljubimcu: ime, pasmina i/ili broj mikročipa."
                  },
                  {
                    "label": "Diagnosis",
                    "value": "U izvještaju nedostaje jasna dijagnoza."
                  },
                  {
                    "label": "Date of visit",
                    "value": "U izvještaju nedostaje datum kad je obavljen pregled."
                  },
                  {
                    "label": "Pages",
                    "value": "U izvještaju koji si nam poslao nedostaju stranice, dokument nije kompletan."
                  },
                  {
                    "label": "Diagnostics tests",
                    "value": "U izvještaju nedostaju rezultati obavljenih pretraga (poput rendgena, nalaza krvi i sl.)."
                  },
                  {
                    "label": "Symptoms/reason for visit",
                    "value": "U izvještaju nedostaje jasan razlog posjeta, odnosno opis simptoma koje tvoj ljubimac ima."
                  },
                  {
                    "label": "Treatment",
                    "value": "U izvještaju nedostaje propisana terapija ili liječenje."
                  }
                ]
              }
            },
            {
              "label": "Inconsistency between documents",
              "value": "Primijetili smo da se podaci u dokumentima baš ne poklapaju: {{inconsistency;STRING;true}}. Trebat će nam službeno pojašnjenje tvog veterinara u obliku novog izvještaja."
            },
            {
              "label": "Previous related reports",
              "value": "Trebaju nam izvještaji s prethodnih pregleda koji su povezani s ovim stanjem (simptomi, kada su počeli, pretrage, terapija i kako se stanje razvijalo). Ako ti je lakše, možeš nam jednostavno poslati cijelu povijest bolesti (veterinarski karton)."
            },
            {
              "label": "Previous visits",
              "value": "Molimo te da nam pošalješ i prethodne izvještaje koji su povezani s ovim pregledom."
            },
            {
              "label": "Costline breakdown",
              "value": "Zamoli svog veterinara da u izvještaju ili u dodatku računu pojedinačno navede svaku obavljenu uslugu i njezinu cijenu."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "Izvještaj i račun se ne poklapaju. Pazi da izvještaj ima isti datum kao i račun te da su na njemu navedene sve stavke koje su naplaćene."
            },
            {
              "label": "Unreadable",
              "value": "Veterinarski izvještaj koji si poslao je mutan ili odrezan. Molimo te da nam pošalješ kompletan dokument u PDF-u."
            },
            {
              "label": "Not a vet report",
              "value": "Ovo što si nam poslao nije veterinarski izvještaj. To mora biti dokument koji je izdao veterinar i u kojem detaljno opisuje pregled. Izvještaj treba sadržavati:\n - <b>Razlog posjeta:</b> npr. „Pas šepa na stražnju nogu.”\n - <b>Simptomi:</b> npr. „Bol na dodir, šepanje.”\n - <b>Kada su simptomi počeli.</b>\n - <b>Pretrage:</b> npr. „Rendgen, opći pregled.”\n - <b>Dijagnoza:</b> npr. „Istegnuće mišića.”\n - <b>Terapija:</b> npr. „Mirovanje, tablete.”"
            },
            {
              "label": "Chronic condition",
              "value": "Za povrat troškova za kronične bolesti, trebat će nam kontrolni izvještaj tvog veterinara koji objašnjava trenutno stanje i tijek liječenja. Ovaj izvještaj morat će se ažurirati svakih 6 mjeseci."
            },
            {
              "label": "Treatment recommendation",
              "value": "U ovom dokumentu vidimo samo preporuku za terapiju, ali nama treba kompletan izvještaj s pregleda."
            },
            {
              "label": "Signed and stamped",
              "value": "Treba nam izvještaj s potpisom i pečatom tvog veterinara. Zamoli kliniku da ti ga tako izda i pošalji nam ga, najbolje u PDF-u."
            },
            {
            "label": "Screenshots Not Accepted",
            "value": "Zaprimili smo tvoj zahtjev za nadoknadu, ali ne možemo prihvatiti snimke zaslona ni fotografije zaslona dokumenata. Molimo te da od svoje klinike zatražiš dokumente u PDF formatu i priložiš ih putem aplikacije."
            }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Certificado de alta del chip",
              "value": "Molimo te da nam pošalješ potvrdu o registraciji (upisu) mikročipa."
            },
            {
              "label": "Contrato de compra o adopción",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Falta",
                    "value": "Treba nam ugovor o kupnji ili ugovor o udomljenju tvog ljubimca."
                  },
                  {
                    "label": "No es legible",
                    "value": "Ugovor o kupnji ili udomljenju koji si poslao nažalost nije čitljiv."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Upiši svoj IBAN za isplatu povrata.",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Ultrasound",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ultrazvuk: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je dokument naknadno mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Treba nam originalni izvještaj s ultrazvuka, na kojem se jasno vide podaci o ljubimcu i datum pretrage."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Nalaz ultrazvuka koji si nam poslao nažalost nije čitljiv."
                  }
                ]
              }
            },
            {
              "label": "Echocardiography",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ehokardiografija: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je dokument mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Treba nam originalni nalaz ehokardiografije (ultrazvuka srca) s podacima o ljubimcu i datumom."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Nalaz ehokardiografije nažalost nije čitljiv."
                  }
                ]
              }
            },
            {
              "label": "Radiography",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Rendgen: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je dokument mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Trebaju nam originalne rendgenske snimke s vodenim žigom ili u DICOM (.dcm) formatu."
                  },
                  {
                    "label": "Original documents",
                    "value": "Trebaju nam originalne rendgenske snimke, idealno u DICOM (.dcm) formatu. Taj format je za rendgen ono što je .jpg za obične fotografije, ti ga možda ne možeš otvoriti na mobitelu, ali mi možemo!"
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rendgenska snimka koju si poslao nije čitljiva."
                  }
                ]
              }
            },
            {
              "label": "MRI",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Magnetska rezonanca: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je dokument mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Treba nam originalni nalaz magnetske rezonance (MR) s podacima o ljubimcu i datumom."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Nalaz magnetske rezonance nije čitljiv."
                  }
                ]
              }
            },
            {
              "label": "TAC",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "CT snimka: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je dokument mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Treba nam originalni nalaz CT-a s podacima o ljubimcu i datumom pretrage."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Nalaz CT-a nažalost nije čitljiv."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Analytics",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Nalazi: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto su podaci mijenjani."
                  },
                  {
                    "label": "Missing",
                    "value": "Trebaju nam originalni rezultati obavljenih pretraga/nalaza s podacima o ljubimcu i datumom."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rezultati nalaza koje si nam poslao nisu čitljivi."
                  }
                ]
              }
            },
            {
              "label": "Biopsy",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Biopsija: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je nalaz mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Treba nam originalni nalaz biopsije na kojem se vide podaci o ljubimcu i datum."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Nalaz biopsije nažalost nije čitljiv."
                  }
                ]
              }
            },
            {
              "label": "Citology",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Citologija: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je nalaz mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Treba nam originalni nalaz citologije s podacima o ljubimcu i datumom."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Nalaz citologije nažalost nije čitljiv."
                  }
                ]
              }
            },
            {
              "label": "Urine test",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Analiza urina: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je nalaz mijenjan."
                  },
                  {
                    "label": "Missing",
                    "value": "Trebaju nam originalni rezultati analize urina s podacima o ljubimcu i datumom pretrage."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rezultati analize urina nažalost nisu čitljivi."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Vaccination card",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava nastale izmjene. U napomeni ćemo ti označiti gdje smo točno uočili promjenu."
                  },
                  {
                    "label": "Missing",
                    "value": "Molimo te da nam pošalješ fotku cijepne knjižice ili putovnice, i to stranice gdje se vide podaci o ljubimcu i sva primljena cijepljenja."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Fotka dokumenta koju si poslao nažalost nije čitljiva."
                  },
                  {
                    "label": "Chipnumber",
                    "value": "Samo nam pošalji fotku one stranice cijepne knjižice ili putovnice na kojoj se jasno vidi broj mikročipa."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    "prevention": {
      "templates": [
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Changes",
              "value": "Cijepna knjižica: potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je dokument mijenjan."
            },
            {
              "label": "Missing",
              "value": "Pošalji nam fotku cijepne knjižice ili putovnice na kojoj se vidi ovo specifično cijepljenje, ali i sva ostala koja je primio."
            },
            {
              "label": "Unreadable",
              "value": "Fotka cijepne knjižice nažalost nije dovoljno čitljiva."
            },
            {
              "label": "Chipnumber",
              "value": "Pošalji nam fotku stranice iz cijepne knjižice ili putovnice na kojoj se jasno vidi broj mikročipa."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Treba nam povijest bolesti (veterinarski karton) tvog ljubimca otkad je s tobom. Zatraži je u svim klinikama u kojima se liječio. Unutra mora biti:\n - <b>Svi posjeti:</b> cijepljenja, kontrole, bolesti ili nesreće.\n - <b>Datumi i bilješke</b> koje je veterinar zapisao.\n - <b>Potvrda da je veterinarski karton kompletan:</b> veterinar treba dopisati nešto poput: „Nema drugih zabilježenih posjeta u ovoj klinici”.\n - <b>Potpis i pečat</b> klinike.\n - Pojedinačne stranice ili nepotpune dokumente nažalost ne možemo prihvatiti."
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Missing",
              "value": "Treba nam originalni izvještaj o obavljenoj pretrazi, s podacima o ljubimcu i točnim datumom."
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Missing",
              "value": "Treba nam originalni nalaz obavljenih pretraga na kojem se vide podaci o ljubimcu i datum."
            }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Chip registration certificate",
              "value": "Molimo te da nam pošalješ potvrdu o registraciji (upisu) mikročipa."
            },
            {
              "label": "Purchase or adoption contract",
              "value": {
                "group": "Što se događa?",
                "options": [
                  {
                    "label": "Missing",
                    "value": "Pošalji nam ugovor o kupnji ili ugovor o udomljenju tvog ljubimca."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Ugovor o kupnji ili udomljenju koji si poslao nažalost nije čitljiv."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Upiši svoj IBAN za isplatu povrata.",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "Changes",
              "value": "Potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je račun naknadno mijenjan."
            },
            {
              "label": "Complete invoice",
              "value": "Treba nam kompletan račun. Najbolje je da ga preuzmeš u PDF formatu i učitaš u aplikaciju, na mjesto za račune. Više spojenih screenshotova nam nažalost ne vrijedi."
            },
            {
              "label": "CIF",
              "value": "Na računu koji si poslao nedostaje OIB klinike ili je nepotpun."
            },
            {
              "label": "Invoice number",
              "value": "Na računu koji si poslao nedostaje broj računa ili je nepotpun."
            },
            {
              "label": "Receipt covers the invoice",
              "value": "Slip od kartice ili blagajnički isječak je prekrio dio računa, pa ne možemo pročitati sve podatke. Makni ga i fotkaj ponovno!"
            },
            {
              "label": "Duplicated invoice",
              "value": "Ovaj račun je već iskorišten za drugog ljubimca. Budući da računi moraju imati jedinstvene brojeve, molimo te da kontaktiraš kliniku i zatražiš ispravan račun za ovog ljubimca."
            },
            {
              "label": "More than one pet",
              "value": "Na ovom računu su pomiješani troškovi za više ljubimaca. Molimo te da nam pošalješ odvojeni račun za svakog osiguranog ljubimca."
            },
            {
              "label": "Missing",
              "value": "Treba nam račun za obavljene usluge. Pazi samo da na njemu jasno pišu <b>OIB</b> klinike, <b>broj računa</b> i <b>datum</b>."
            },
            {
              "label": "Unreadable",
              "value": "Račun koji si poslao je mutan ili odrezan. Molimo te da nam pošalješ čitljiv, kompletan račun u PDF-u."
            },
            {
              "label": "Not an invoice",
              "value": "Dokument koji si nam poslao nije službeni račun. Bez brige, samo se javi svom veterinaru ili ljekarni da ti izdaju onaj pravi račun na kojem se jasno vide <b>OIB</b> klinike, <b>broj računa</b> i <b>datum</b>. Ponude, predračuni ili računi s brojem 0 nam nažalost ne vrijede prema uvjetima osiguranja."
            },
            {
              "label": "One single document",
              "value": "Molimo te da nam račun pošalješ kao jedan dokument, idealno u PDF-u. Ovako nam se malo pomiješao redoslijed. Ako imaš tiskani račun koji treba pofotkati, samo pazi da cijeli stane na jednu sliku."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Primili smo tvoj zahtjev za povrat novca, ali nažalost ne možemo prihvatiti screenshotove ni fotografije ekrana. Zamoli svoju kliniku da ti dokumente izda u PDF-u i učitaj ih u aplikaciju."
            },
            {
              "label": "Signed and stamped",
              "value": "Treba nam račun s potpisom i pečatom tvog veterinara. Zamoli kliniku da ti ga tako izda i pošalji nam ga, najbolje u PDF-u."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline explanation",
              "value": "Zamoli svog veterinara da u izvještaju ili dodatku računu pojasni na što se odnose ove stavke: {{línea_de_coste;STRING;true}}. Treba nam naziv tretmana i njegova pojedinačna cijena."
            },
            {
              "label": "Changes",
              "value": "Potreban nam je službeni izvještaj s potpisom i pečatom veterinara koji objašnjava zašto je dokument naknadno mijenjan."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Što nedostaje?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Nedostaje nam veterinarski izvještaj iz ove klinike: {{clinica;STRING;true}}."
                  },
                  {
                    "label": "All",
                    "value": "Treba nam veterinarski izvještaj. To je dokument koji piše veterinar i u kojem detaljno opisuje pregled. Izvještaj mora sadržavati:\n\n<b>Razlog posjeta:</b> npr. „Pas šepa na stražnju nogu.”\n\n<b>Simptomi:</b> npr. „Bol na dodir, šepanje.”\n\n<b>Kada su simptomi počeli.</b>\n\n<b>Pretrage:</b> npr. „Rendgen, opći pregled.”\n\n<b>Dijagnoza:</b> npr. „Istegnuće mišića.”\n\n<b>Terapija:</b> npr. „Mirovanje, tablete.”"
                  },
                  {
                    "label": "Dates",
                    "value": "Nedostaje nam veterinarski izvještaj za ove datume: {{fecha;DATE_RANGE;true}}."
                  }
                ]
              }
            },
            {
              "label": "Not a vet report",
              "value": "Ovo što si nam poslao nije veterinarski izvještaj. To mora biti dokument koji je izdao veterinar i u kojem detaljno opisuje pregled. Izvještaj treba sadržavati:\n - <b>Razlog posjeta:</b> npr. „Pas šepa na stražnju nogu.”\n - <b>Simptomi:</b> npr. „Bol na dodir, šepanje.”\n - <b>Kada su simptomi počeli.</b>\n - <b>Pretrage:</b> npr. „Rendgen, opći pregled.”\n - <b>Dijagnoza:</b> npr. „Istegnuće mišića.”\n - <b>Terapija:</b> npr. „Mirovanje, tablete.”"
            },
            {
              "label": "Costline breakdown",
              "value": "Zamoli svog veterinara da u izvještaju ili u dodatku računu pojedinačno navede svaku obavljenu uslugu i njezinu cijenu."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "Izvještaj i račun se ne poklapaju, a računi moraju uvijek biti povezani s pripadajućim izvještajima s pregleda."
            },
            {
              "label": "Unreadable",
              "value": "Veterinarski izvještaj koji si poslao je mutan ili odrezan. Molimo te da nam pošalješ kompletan dokument u PDF-u."
            },
            {
              "label": "Signed and stamped",
              "value": "Treba nam izvještaj s potpisom i pečatom tvog veterinara. Zamoli kliniku da ti ga tako izda i pošalji nam ga, najbolje u PDF-u."
            },
            {
            "label": "Screenshots Not Accepted",
            "value": "Zaprimili smo tvoj zahtjev za nadoknadu, ali ne možemo prihvatiti snimke zaslona ni fotografije zaslona dokumenata. Molimo te da od svoje klinike zatražiš dokumente u PDF formatu i priložiš ih putem aplikacije."
            }
          ]
        }
      ]
    }
  },
  "resolution": {
    "templates": [
      {
        "group": "Waiting period",
        "options": [
          {
            "label": "5 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Nakon pregleda dokumentacije za {{petName}}, obavještavamo te da tvoj račun, ili njegov dio, nije mogao biti odobren. Tvoja polica ima rok čekanja od 5 dana za nezgode od datuma sklapanja ugovora. U ovom slučaju, navedeno stanje: {{condition;STRING;true}}, pojavilo se ili je primilo veterinarsku skrb dana: {{date;DATE;true}}, unutar tih 5 dana. Iz tog razloga nije pokriveno osiguranjem i smatra se postojećim prije sklapanja police. Ako se ovo stanje produlji ili se u budućnosti ponovno pojavi u ponavljajućem ili kroničnom obliku, ni ova epizoda ni eventualni recidivi ili komplikacije koje iz nje proizlaze neće moći biti nadoknađeni, bez obzira na datum konačne dijagnoze."
          },
          {
            "label": "28 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Nakon što smo pregledali dokumentaciju za {{petName}}, obavještavamo te da tvoj račun, ili njegov dio, nije mogao biti odobren. Tvoja polica ima rok čekanja od 28 dana za bolesti od datuma sklapanja ugovora. Polica definira poseban popis situacija sa skraćenim rokom čekanja od 5 dana, a ovo stanje nažalost nije među njima, stoga se primjenjuje opći rok čekanja od 28 dana. U ovom slučaju, navedeno stanje: {{condition;STRING;true}}, pojavilo se ili je primilo veterinarsku skrb dana: {{date;DATE;true}}, unutar tih 28 dana, te se klasificira kao bolest jer ne ispunjava uvjete utvrđene policom da bi se smatralo nezgodom. Iz tog razloga nije pokriveno osiguranjem i smatra se postojećim prije sklapanja police. Ako se ovo stanje produlji ili se u budućnosti ponovno pojavi u ponavljajućem ili kroničnom obliku, ni ova epizoda ni eventualni recidivi ili komplikacije koje iz nje proizlaze neće moći biti nadoknađeni, bez obzira na datum konačne dijagnoze."
          },
          {
            "label": "6 MONTH WAITING PERIOD / PREEXISTENCE",
            "value": "Nakon pregleda dokumentacije za {{petName}}, obavještavamo te da tvoj račun, ili njegov dio, nije mogao biti odobren. Tvoja polica predviđa rok čekanja od 6 mjeseci za određena stanja od datuma sklapanja ugovora. Među ta stanja ubrajaju se: displazija kuka, displazija lakta, puknuće ili bolest križnog ligamenta, iščašenje patele, atopija, alergijski dermatitis, epilepsija, poremećaji ponašanja, lišmanioza, katarakta i hernija diska. Ako je ljubimac imao više od 6 mjeseci u trenutku sklapanja police, ta stanja podliježu tom roku od 6 mjeseci, čak i ako bi njihov uzrok mogao biti povezan s neočekivanim događajem. U ovom slučaju, navedeno stanje: {{condition;STRING;true}}, pojavilo se ili je liječeno dana: {{date;DATE;true}}, unutar tog razdoblja od 6 mjeseci. Stoga nije pokriveno osiguranjem i smatra se postojećim prije sklapanja police. Ovo stanje ostat će isključeno iz pokrića i ubuduće: budući da su se prvi simptomi ili prvi povezani veterinarski pregled dogodili unutar roka čekanja police, ne možemo odobriti buduće zahtjeve za nadoknadu povezane s ovim stanjem ili bilo kojim simptomom, ozljedom ili bolešću koja iz njega proizlazi. Ovo stanje trajno će se smatrati postojećim prije sklapanja police, čak i ako se konačna dijagnoza potvrdi kasnije."
          }
        ]
      },
      {
        "group": "Preexistence",
        "options": [
          {
            "label": "Preexistence/before contract",
                        "value": "Nakon pregleda dokumentacije za {{petName}}, obavještavamo te da tvoj račun, ili njegov dio, nije mogao biti odobren.\n\nStanje koje tvoj ljubimac ima: {{condition;STRING;true}}, smatra se postojećim prije sklapanja police, budući da se pojavilo, pokazalo simptome ili je prvi put liječeno dana: {{date;DATE;true}}, prije početka pokrića.\n\nPostojeće stanje je svaka ozljeda ili bolest koja: se pojavila ili pokazala kliničke simptome prije početka pokrića police, ili ima istu dijagnozu ili iste simptome kao ozljeda ili bolest koju je ljubimac imao prije početka pokrića, ili je uzrokovana, povezana s ili proizlazi iz ozljede, bolesti ili kliničkog simptoma koji je prethodio početku pokrića.\n\nOsim toga, ovo stanje ostat će isključeno iz pokrića i ubuduće. To znači da ne možemo odobriti buduće zahtjeve za nadoknadu povezane s ovim stanjem ili bilo kojim simptomom, ozljedom ili bolešću koja iz njega proizlazi, čak i ako se konačna dijagnoza potvrdi kasnije."
          },
          {
            "label": "Same diagnosis in different body part",
            "value": "Samo mala napomena: prema uvjetima tvoje police, ako je tvoj ljubimac prije početka osiguranja ili tijekom razdoblja čekanja (karence) već imao problema s nečim od navedenog (hernija ili protruzija diska, puknuće ili bolest križnih ligmenata, luksacija patele, displazija lakta ili kuka, katarakta ili osteoartritis), troškovi za tu istu bolest neće biti pokriveni čak i ako se kasnije pojavi na potpuno drugom dijelu tijela.\n\nPrimjerice, to uključuje herniju na nekom drugom kralješku ili puknuće križnog ligamenta na drugoj nozi."
          },
          {
            "label": "Date outside coverage period",
            "value": "Račun je izdan prije ugovaranja police: nažalost, morali smo odbiti tvoj zahtjev jer je datum na računu stariji od datuma kada je tvoje osiguranje počelo vrijediti."
          },
          {
            "label": "Not an accident denial",
            "value": "Pregledali smo tvoj zahtjev i, prema Općim uvjetima tvoje police, ovaj se slučaj nažalost ne može voditi kao nesretni slučaj.\n\nDa bi se nešto vodilo kao nesretni slučaj, mora odgovarati definiciji nesretnog slučaja iz ugovora i biti na popisu pokrivenih nesretnih slučajeva, a to su isključivo:\n - Prijelomi ili iščašenja zglobova nastali uslijed traume.\n - Razderotine kože, ugrizne rane (osim uboda insekata) ili ogrebotine.\n - Opekline ili ozljede od strujnog udara.\n - Ozljede koje je uzrokovalo vozilo.\n - Trovanja.\n - Rane od vatrenog oružja ili projektila.\n - Teške kontuzije ili ozljede od gnječenja.\n - Traumatske ozljede zuba.\n - Strana tijela u probavnom sustavu.\n\nUz to, Opći uvjeti izričito navode da ozljede ili stanja koja, čak i uz traumatski događaj, odgovaraju bolesti s vlastitim razdobljem čekanja (karencom) podliježu toj karenci, a ne onoj za nesretni slučaj.\n\nZato se na ovaj slučaj primjenjuje karenca od 28 dana, a ne karenca od 5 dana koja vrijedi za nesretni slučaj. Budući da su se simptomi i/ili liječenje dogodili unutar te karence, nažalost ti ne možemo odobriti povrat ovih troškova."
          }
        ]
      },
      {
        "group": "Vaccinations are not up to date",
        "options": [
          {
            "label": "Vaccinations are not up to date",
            "value": "Godišnje cijepljenje tvog ljubimca nije ažurirano. Prema općim uvjetima tvoje police, ljubimac mora biti redovito cijepljen protiv bjesnoće, štenećaka, hepatitisa i parvoviroze. U ovom slučaju raspored cijepljenja nije potpun ili se niste držali uputa veterinara, pa nažalost ne možemo pokriti troškove liječenja koji su proizašli iz te bolesti."
          }
        ]
      },
      {
        "group": "Disclaimer",
        "options": [
          {
            "label": "Disclaimer Clinical history",
            "value": "Povijest bolesti (veterinarski karton). Samo te želimo podsjetiti da će nam uz idući zahtjev za povrat novca trebati i kompletna povijest bolesti tvog ljubimca. To je jedan dokument koji sadržava baš sve posjete veterinaru, zbog bolesti, nesreće, ali i rutinske kontrole ili cijepljenja, s datumima i bilješkama. Ako ste išli u više klinika, morat ćeš je zatražiti u svakoj od njih. Svaka stranica mora biti numerirana, a na zadnjoj nam treba potpis i pečat klinike, uz potvrdu da su to jedini posjeti tvog ljubimca toj klinici."
          },
          {
            "label": "More than one pet",
            "value": "Kako bismo ti brže odobrili povrate u budućnosti, naš savjet je da na jednom računu bude samo jedan ljubimac. Računi na kojima ima više ljubimaca mogu usporiti proces jer moramo tražiti dodatna pojašnjenja."
          },
          {
            "label": "Complementary sessions limit reacheds",
            "value": "Samo info da si iskoristio svih 8 dopunskih terapija/tretmana koji su uključeni u tvoju trenutnu godinu osiguranja."
          },
          {
            "label": "Annual visit limit reached",
            "value": "Već si iskoristio godišnji pregled koji je pokriven tvojom policom."
          },
          {
            "label": "Unjustified costlines",
            "value": "Neki od navedenih troškova nisu dovoljno pojašnjeni u dokumentaciji koju si nam poslao, pa ih prema uvjetima osiguranja nismo mogli odobriti."
          },
          {
            "label": "Outside EU, UK and Andorra",
            "value": "Tvoja polica nažalost ne pokriva veterinarske troškove koji su nastali izvan Europske unije, Ujedinjenog Kraljevstva i Andore."
          },
          {
            "label": "Disclaimer chronic condition revision",
            "value": "Kontrolni izvještaj. Podsjećamo te da je za povrat novca za lijekove kod kroničnih bolesti potrebno obaviti kontrolu svakih 6 mjeseci. Molimo te da nam uz idući zahtjev pošalješ taj novi kontrolni izvještaj."
          },
          {
            "label": "Prostheses, implants, pacemakers and transplants",
            "value": "Tvoja polica nažalost ne pokriva transplantacije (uključujući njegu prije i nakon operacije), srčane elektrostimulatore (pacemakere), proteze i implantate (osim implantata za osteosintezu), kao ni umjetne dijelove tijela ili umjetne zglobove."
          }
        ]
      },
      {
        "group": "Preventative/routinary costline",
        "options": [
          {
            "label": "Preventative/routinary costline",
            "value": "Preventivni tretman. Barkibu osiguranje pokriva veterinarske troškove koji su nastali zbog bolesti ili nesreće. Troškovi koje si nam poslao odnose se na rutinske ili preventivne tretmane, pa nažalost nisu pokriveni."
          }
        ]
      },
      {
        "group": "Postmortem",
        "options": [
          {
            "label": "Our condolences",
            "value": "U ime cijele Barkibu ekipe, želimo ti poslati puno snage u ovim teškim trenucima. Iskreno nam je žao zbog tvog gubitka."
          }
        ]
      },
      {
        "group": "Prevention outside of country",
        "options": [
          {
            "label": "Prevention outside of country",
            "value": "Tvoja polica za preventivnu njegu vrijedi isključivo na području Hrvatske."
          }
        ]
      },
      {
        "group": "Shunt/congenital malformation",
        "options": [
          {
            "label": "Shunt/congenital malformation",
            "value": "Prema općim uvjetima, troškovi povezani s prirođenim krvožilnim ili srčanim manama (kao što su portosistemski šant ili PDA) nažalost nisu pokriveni, čak i ako niste znali za njih u trenutku ugovaranja osiguranja."
          }
        ]
      },
      {
        "group": "Brachycephalic Syndrome",
        "options": [
          {
            "label": "Brachycephalic Syndrome",
            "value": "Brahicefalični sindrom je isključen iz pokrića prema Općim uvjetima tvoje police. Zbog toga troškovi njegove dijagnoze i liječenja nažalost ne mogu biti odobreni za povrat."
          }
        ]
      },
      {
        "group": "Annual limit reached",
        "options": [
          {
            "label": "Annual limit reached",
            "value": "Samo te želimo obavijestiti da je dosegnut maksimalni godišnji limit na tvojoj polici."
          }
        ]
      },
      {
        "group": "Prevention",
        "options": [
          {
            "label": "Vaccinations not covered",
            "value": "Ovo cjepivo nije pokriveno. Paket preventive na tvom osiguranju pokriva cjepivo protiv bjesnoće, polivalentno i protiv zaraznog kašlja za pse, odnosno cjepivo protiv bjesnoće, trivalentno i protiv leukemije za mace."
          },
          {
            "label": "Annual visit with tests",
            "value": "Godišnji pregled s pretragama: paket preventive uključuje jedan godišnji preventivni pregled koji nije povezan s nikakvom bolešću, nesretnim slučajem ili simptomima. Ovaj pregled ne uključuje dodatne pretrage ili nalaze. Pregled koji si nam poslao ne ispunjava ove uvjete pa ga nismo mogli pokriti."
          }
        ]
      }
    ]
  },
  "close_claim": {
    "templates": [
      {
        "group": "Zatvaranje zahtjeva",
        "options": [
          {
            "label": "Missing information",
            "value": "Zatvorili smo tvoj zahtjev jer dokumentacija koju imamo nije dovoljna da bismo ga procijenili. Označili smo ti u aplikaciji što nam sve treba, ali nismo primili ispravne papire. Ako želiš da ponovno sve pogledamo, samo pokreni novi zahtjev i priloži sve tražene dokumente."
          },
          {
            "label": "Outstanding documents in another request",
            "value": "Zatvorili smo ovaj zahtjev jer je povezan s drugim zahtjevom koji je još otvoren i čeka tvoje dokumente. Molimo te da tražene papire učitaš izravno u onaj zahtjev koji u aplikaciji ima status „Nedostaje dokumentacija”."
          },
          {
            "label": "Duplicated invoice",
            "value": "Zatvorili smo ovaj zahtjev jer smo nakon provjere računa shvatili da su oni već predani i obrađeni u jednom od prethodnih zahtjeva."
          },
          {
            "label": "Erroneous pet",
            "value": "Zatvorili smo tvoj zahtjev jer poslani troškovi ne odgovaraju ljubimcu koji je osiguran ovom policom."
          },
          {
            "label": "Suspended/cancelled policy",
            "value": "Zatvorili smo tvoj zahtjev jer ti je polica trenutno zamrznuta (suspendirana). Pokušali smo te kontaktirati više puta oko ažuriranja plaćanja i otplate propuštenih rata, ali bez uspjeha. Čim riješiš zaostatke, moći ćeš bez problema poslati novi zahtjev kroz aplikaciju."
          },
          {
            "label": "Pet parent asked to close the claim",
            "value": "Zatvorili smo zahtjev jer si nas ti tako tražio."
          },
          {
            "label": "Fraud documentation from clinic",
            "value": "Zbog nepodudarnosti uočenih u prethodnim zahtjevima za povrat, od sada svu dokumentaciju za buduće povrate mora izravno poslati vaša veterinarska klinika na clinic@barkibu.com.\n\nNakon što je vaša klinika pošalje, važno je da putem aplikacije otvorite novi zahtjev s istim dokumentima uz napomenu: „Moja klinika već je poslala dokumentaciju\", kako bismo je mogli pregledati.\n\nMolimo vas da radi lakše obrade vaših povrata nikada ne kreirate zahtjev s dokumentima koje nam vaša klinika nije prethodno poslala na gore navedenu e-mail adresu."
          },
          {
            "label": "No response from clinic",
            "value": "Zatvorili smo tvoj zahtjev jer s dosad dostavljenom dokumentacijom nemamo dovoljno informacija za donošenje procjene. Nekoliko smo puta pokušali kontaktirati tvoju kliniku kako bismo upotpunili informacije, ali bezuspješno.\n\nKako bismo mogli pregledati tvoje zahtjeve, obrati se svojoj klinici da provjeri svoju e-poštu.\n\nNakon što nam odgovore, moći ćeš ponovno otvoriti zahtjev putem aplikacije."
          },
          {
            "label": "Fraud",
            "value": "Nakon pregleda dostavljene dokumentacije utvrdili smo nepodudarnosti koje nas sprječavaju da odobrimo vaš zahtjev.\n\nOd sada se sva dokumentacija za buduće povrate mora slati izravno od strane vaše veterinarske klinike na clinic@barkibu.com.\n\nNakon što je vaša klinika pošalje, važno je da ponovno otvorite zahtjev putem aplikacije s istim dokumentima, uz napomenu: „Moja klinika već je poslala dokumentaciju\", kako bismo je mogli pregledati.\n\nMolimo vas da, radi lakše obrade vaših povrata, nikada ne kreirate zahtjev s dokumentima koje nam vaša klinika prethodno nije poslala na gore navedenu e-mail adresu."
          }
        ]
      }
    ]
  }
}
